const registrar_observacao_relatorio_final_turma = [
  {
    path: "/registrar-observacao-relatorio-final-turma",
    name: "registrar_observacao_relatorio_final_turma",
    meta: {
      allowedPermissions: ["relatoriofinal_observacao_turma"],
      breadCrumb: "Processo de Resultado Final - Relatório Final Turma",
    },
    component: () =>
      import(
        "@/views/RegistrarObservacaoRelatorioFinalTurma/RegistrarObservacaoRelatorioFinalTurma.vue"
      ),
  },
];

export { registrar_observacao_relatorio_final_turma };
